// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  width: 265px;
  min-width: 265px;
  max-width: 265px;
  height: 100%;
  font-family: "Figtree", sans-serif;
}

.sidenav-menu-outer {
  width: 265px;
  min-width: 265px;
  max-width: 265px;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border-right: 1px solid #e8ecf6;
  box-shadow: 2px 0 16px rgba(40, 53, 147, 0.06);
  overflow: hidden;
}

.brand-header {
  padding: 18px 16px 14px;
  border-bottom: 1px solid #f0f3fc;
  flex-shrink: 0;
}

.brand-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-tile {
  width: 60px;
  height: 60px;
  border-radius: 10px;
  background: #f4f6ff;
  border: 1px solid #e0e4f8;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.logo-tile img {
  width: 55px;
  height: 55px;
  object-fit: cover;
  border-radius: 8px;
}

.logo-container {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.edit-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
  cursor: pointer;
}
.edit-overlay mat-icon {
  color: white;
  font-size: 18px;
  width: 18px;
  height: 18px;
}

.logo-container:hover .edit-overlay {
  opacity: 1;
}

.clickable-logo {
  cursor: pointer;
}

.brand-text {
  min-width: 0;
  flex: 1;
}

.org-name {
  font-size: 12px;
  font-weight: 600;
  color: #1a2060;
  direction: rtl;
  text-align: right;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.org-subtitle {
  font-size: 10px;
  font-weight: 400;
  color: #8898c8;
  text-align: right;
}

.selector-wrap {
  margin-top: 12px;
}

.pill-select {
  position: relative;
}

.pill-select + .pill-select {
  margin-top: 8px;
}

.pill-button {
  width: 100%;
  border-radius: 8px;
  border: 1px solid #e0e4f8;
  background: #f4f6ff;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: border-color 150ms ease, background 150ms ease;
}

.pill-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.pill-text-col {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
  text-align: start;
}

.pill-value {
  font-size: 11.5px;
  font-weight: 500;
  color: var(--color-sidenav-text);
  flex: 1;
  text-align: start;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pill-sub {
  font-size: 9.5px;
  color: #8898c8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2;
}

.pill-chevron {
  font-size: 18px;
  width: 18px;
  height: 18px;
  color: #8898c8;
  transition: transform 150ms ease;
}

.pill-chevron.open {
  transform: rotate(180deg);
}

.pill-options {
  background: #ffffff;
  border: 1px solid #e0e4f8;
  border-top: 0;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 4px 12px rgba(40, 53, 147, 0.1);
  overflow: hidden;
}

.pill-option {
  width: 100%;
  border: 0;
  background: transparent;
  text-align: start;
  padding: 9px 14px;
  font-size: 12px;
  font-weight: 400;
  color: #5a6888;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background 150ms ease, color 150ms ease;
}

.pill-option .pill-dot {
  opacity: 0;
}

.pill-option:hover {
  background: #f4f6ff;
  color: var(--color-sidenav-text);
}

.pill-option.selected {
  color: var(--color-sidenav-text);
  font-weight: 600;
}

.pill-option.selected .pill-dot {
  opacity: 1;
}

.pill-option-col {
  display: flex;
  flex-direction: column;
  min-width: 0;
  flex: 1;
  text-align: start;
}

.pill-service-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pill-service-sub {
  font-size: 10px;
  font-weight: 400;
  color: #8898c8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.pill-select.role .pill-dot {
  background: var(--color-pill-role-dot);
  box-shadow: 0 0 0 2px var(--shadow-primary-sm);
}

.pill-select.role .pill-button:hover {
  border-color: var(--color-pill-role-dot);
  background: #eef0fc;
}

.pill-select.service .pill-button {
  border-color: #e0f2f0;
  background: #f4fffe;
}

.pill-select.service .pill-dot {
  background: #00897b;
  box-shadow: 0 0 0 2px rgba(0, 137, 123, 0.2);
}

.pill-select.service .pill-value {
  color: #00695c;
}

.pill-select.service .pill-button:hover {
  border-color: #00897b;
  background: #e8f5f3;
}

.pill-select.service .pill-option:hover {
  background: #e8f5f3;
  color: #00695c;
}

.pill-select.service .pill-option.selected {
  color: #00695c;
}

.nav-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 12px 10px 16px;
  scrollbar-width: thin;
  scrollbar-color: #e0e4f0 transparent;
}

.nav-body::-webkit-scrollbar {
  width: 3px;
}

.nav-body::-webkit-scrollbar-thumb {
  background: #e0e4f0;
  border-radius: 3px;
}

.user-footer {
  flex-shrink: 0;
  border-top: 1px solid #f0f3fc;
  background: #fafbff;
  padding: 10px 14px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--color-sidenav-avatar-start), var(--color-sidenav-avatar-end));
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  color: #fff;
  flex-shrink: 0;
}

.user-info {
  min-width: 0;
  flex: 1;
}

.user-name {
  font-size: 11.5px;
  font-weight: 600;
  color: #1a2060;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-role {
  font-size: 10px;
  font-weight: 400;
  color: #8898c8;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.logout-btn {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  border: 1px solid #e8ecf6;
  background: #fff;
  color: #8898c8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;
}

.change-password-btn {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  border: 1px solid #e8ecf6;
  background: #fff;
  color: #8898c8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;
}

.change-password-btn .material-icons {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.change-password-btn:hover {
  background: #eef3ff;
  border-color: #c8d7ff;
  color: var(--color-sidenav-text);
}

.logout-btn .material-icons {
  font-size: 16px;
  width: 16px;
  height: 16px;
}

.logout-btn:hover {
  background: #fff0f0;
  border-color: #ffcdd2;
  color: #e53935;
}`, "",{"version":3,"sources":["webpack://./src/app/theme/components/sidenav/sidenav.component.scss","webpack://./../../LMS_v20_Before%20Security%20Audit%20Fixes/Edulink/src/app/theme/components/sidenav/sidenav.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,kCAAA;ACCF;;ADEA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,+BAAA;EACA,8CAAA;EACA,gBAAA;ACCF;;ADEA;EACE,uBAAA;EACA,gCAAA;EACA,cAAA;ACCF;;ADEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;ACCF;;ADEA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;ACCF;;ADEA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;ACCF;;ADEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;ACCF;;ADEA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,oCAAA;EACA,eAAA;ACCF;ADCE;EACE,YAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;ACCJ;;ADGA;EACE,UAAA;ACAF;;ADGA;EACE,eAAA;ACAF;;ADGA;EACE,YAAA;EACA,OAAA;ACAF;;ADGA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ACAF;;ADGA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;ACAF;;ADGA;EACE,gBAAA;ACAF;;ADGA;EACE,kBAAA;ACAF;;ADGA;EACE,eAAA;ACAF;;ADGA;EACE,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,0DAAA;ACAF;;ADGA;EACE,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;ACAF;;ADGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,OAAA;EACA,iBAAA;ACAF;;ADGA;EACE,iBAAA;EACA,gBAAA;EACA,gCAAA;EACA,OAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ACAF;;ADGA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;ACAF;;ADGA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,gCAAA;ACAF;;ADGA;EACE,yBAAA;ACAF;;ADGA;EACE,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,0BAAA;EACA,6CAAA;EACA,gBAAA;ACAF;;ADGA;EACE,WAAA;EACA,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mDAAA;ACAF;;ADGA;EACE,UAAA;ACAF;;ADGA;EACE,mBAAA;EACA,gCAAA;ACAF;;ADGA;EACE,gCAAA;EACA,gBAAA;ACAF;;ADGA;EACE,UAAA;ACAF;;ADGA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,OAAA;EACA,iBAAA;ACAF;;ADGA;EACE,mBAAA;EACA,gBAAA;EACA,uBAAA;ACAF;;ADGA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ACAF;;ADGA;EACE,sCAAA;EACA,8CAAA;ACAF;;ADGA;EACE,wCAAA;EACA,mBAAA;ACAF;;ADGA;EACE,qBAAA;EACA,mBAAA;ACAF;;ADGA;EACE,mBAAA;EACA,4CAAA;ACAF;;ADGA;EACE,cAAA;ACAF;;ADGA;EACE,qBAAA;EACA,mBAAA;ACAF;;ADGA;EACE,mBAAA;EACA,cAAA;ACAF;;ADGA;EACE,cAAA;ACAF;;ADGA;EACE,OAAA;EACA,aAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oCAAA;ACAF;;ADGA;EACE,UAAA;ACAF;;ADGA;EACE,mBAAA;EACA,kBAAA;ACAF;;ADGA;EACE,cAAA;EACA,6BAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;ACAF;;ADGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uGAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,cAAA;ACAF;;ADGA;EACE,YAAA;EACA,OAAA;ACAF;;ADGA;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ACAF;;ADGA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;ACAF;;ADGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,4EAAA;ACAF;;ADGA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,4EAAA;ACAF;;ADGA;EACE,eAAA;EACA,WAAA;EACA,YAAA;ACAF;;ADGA;EACE,mBAAA;EACA,qBAAA;EACA,gCAAA;ACAF;;ADGA;EACE,eAAA;EACA,WAAA;EACA,YAAA;ACAF;;ADGA;EACE,mBAAA;EACA,qBAAA;EACA,cAAA;ACAF","sourcesContent":[":host {\n  display: block;\n  width: 265px;\n  min-width: 265px;\n  max-width: 265px;\n  height: 100%;\n  font-family: 'Figtree', sans-serif;\n}\n\n.sidenav-menu-outer {\n  width: 265px;\n  min-width: 265px;\n  max-width: 265px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  border-right: 1px solid #e8ecf6;\n  box-shadow: 2px 0 16px rgba(40, 53, 147, 0.06);\n  overflow: hidden;\n}\n\n.brand-header {\n  padding: 18px 16px 14px;\n  border-bottom: 1px solid #f0f3fc;\n  flex-shrink: 0;\n}\n\n.brand-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.logo-tile {\n  width: 60px;\n  height: 60px;\n  border-radius: 10px;\n  background: #f4f6ff;\n  border: 1px solid #e0e4f8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.logo-tile img {\n  width: 55px;\n  height: 55px;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.logo-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.edit-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out;\n  cursor: pointer;\n\n  mat-icon {\n    color: white;\n    font-size: 18px;\n    width: 18px;\n    height: 18px;\n  }\n}\n\n.logo-container:hover .edit-overlay {\n  opacity: 1;\n}\n\n.clickable-logo {\n  cursor: pointer;\n}\n\n.brand-text {\n  min-width: 0;\n  flex: 1;\n}\n\n.org-name {\n  font-size: 12px;\n  font-weight: 600;\n  color: #1a2060;\n  direction: rtl;\n  text-align: right;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.org-subtitle {\n  font-size: 10px;\n  font-weight: 400;\n  color: #8898c8;\n  text-align: right;\n}\n\n.selector-wrap {\n  margin-top: 12px;\n}\n\n.pill-select {\n  position: relative;\n}\n\n.pill-select+.pill-select {\n  margin-top: 8px;\n}\n\n.pill-button {\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid #e0e4f8;\n  background: #f4f6ff;\n  padding: 8px 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  transition: border-color 150ms ease, background 150ms ease;\n}\n\n.pill-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.pill-text-col {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  flex: 1;\n  text-align: start;\n}\n\n.pill-value {\n  font-size: 11.5px;\n  font-weight: 500;\n  color: var(--color-sidenav-text);\n  flex: 1;\n  text-align: start;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pill-sub {\n  font-size: 9.5px;\n  color: #8898c8;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.2;\n}\n\n.pill-chevron {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n  color: #8898c8;\n  transition: transform 150ms ease;\n}\n\n.pill-chevron.open {\n  transform: rotate(180deg);\n}\n\n.pill-options {\n  background: #ffffff;\n  border: 1px solid #e0e4f8;\n  border-top: 0;\n  border-radius: 0 0 8px 8px;\n  box-shadow: 0 4px 12px rgba(40, 53, 147, 0.1);\n  overflow: hidden;\n}\n\n.pill-option {\n  width: 100%;\n  border: 0;\n  background: transparent;\n  text-align: start;\n  padding: 9px 14px;\n  font-size: 12px;\n  font-weight: 400;\n  color: #5a6888;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: background 150ms ease, color 150ms ease;\n}\n\n.pill-option .pill-dot {\n  opacity: 0;\n}\n\n.pill-option:hover {\n  background: #f4f6ff;\n  color: var(--color-sidenav-text);\n}\n\n.pill-option.selected {\n  color: var(--color-sidenav-text);\n  font-weight: 600;\n}\n\n.pill-option.selected .pill-dot {\n  opacity: 1;\n}\n\n.pill-option-col {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  flex: 1;\n  text-align: start;\n}\n\n.pill-service-title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pill-service-sub {\n  font-size: 10px;\n  font-weight: 400;\n  color: #8898c8;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pill-select.role .pill-dot {\n  background: var(--color-pill-role-dot);\n  box-shadow: 0 0 0 2px var(--shadow-primary-sm);\n}\n\n.pill-select.role .pill-button:hover {\n  border-color: var(--color-pill-role-dot);\n  background: #eef0fc;\n}\n\n.pill-select.service .pill-button {\n  border-color: #e0f2f0;\n  background: #f4fffe;\n}\n\n.pill-select.service .pill-dot {\n  background: #00897b;\n  box-shadow: 0 0 0 2px rgba(0, 137, 123, 0.2);\n}\n\n.pill-select.service .pill-value {\n  color: #00695c;\n}\n\n.pill-select.service .pill-button:hover {\n  border-color: #00897b;\n  background: #e8f5f3;\n}\n\n.pill-select.service .pill-option:hover {\n  background: #e8f5f3;\n  color: #00695c;\n}\n\n.pill-select.service .pill-option.selected {\n  color: #00695c;\n}\n\n.nav-body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 12px 10px 16px;\n  scrollbar-width: thin;\n  scrollbar-color: #e0e4f0 transparent;\n}\n\n.nav-body::-webkit-scrollbar {\n  width: 3px;\n}\n\n.nav-body::-webkit-scrollbar-thumb {\n  background: #e0e4f0;\n  border-radius: 3px;\n}\n\n.user-footer {\n  flex-shrink: 0;\n  border-top: 1px solid #f0f3fc;\n  background: #fafbff;\n  padding: 10px 14px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.user-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--color-sidenav-avatar-start), var(--color-sidenav-avatar-end));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 700;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.user-info {\n  min-width: 0;\n  flex: 1;\n}\n\n.user-name {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: #1a2060;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.user-role {\n  font-size: 10px;\n  font-weight: 400;\n  color: #8898c8;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.logout-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 7px;\n  border: 1px solid #e8ecf6;\n  background: #fff;\n  color: #8898c8;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;\n}\n\n.change-password-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 7px;\n  border: 1px solid #e8ecf6;\n  background: #fff;\n  color: #8898c8;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;\n}\n\n.change-password-btn .material-icons {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n}\n\n.change-password-btn:hover {\n  background: #eef3ff;\n  border-color: #c8d7ff;\n  color: var(--color-sidenav-text);\n}\n\n.logout-btn .material-icons {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n}\n\n.logout-btn:hover {\n  background: #fff0f0;\n  border-color: #ffcdd2;\n  color: #e53935;\n}",":host {\n  display: block;\n  width: 265px;\n  min-width: 265px;\n  max-width: 265px;\n  height: 100%;\n  font-family: \"Figtree\", sans-serif;\n}\n\n.sidenav-menu-outer {\n  width: 265px;\n  min-width: 265px;\n  max-width: 265px;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: #ffffff;\n  border-right: 1px solid #e8ecf6;\n  box-shadow: 2px 0 16px rgba(40, 53, 147, 0.06);\n  overflow: hidden;\n}\n\n.brand-header {\n  padding: 18px 16px 14px;\n  border-bottom: 1px solid #f0f3fc;\n  flex-shrink: 0;\n}\n\n.brand-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.logo-tile {\n  width: 60px;\n  height: 60px;\n  border-radius: 10px;\n  background: #f4f6ff;\n  border: 1px solid #e0e4f8;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.logo-tile img {\n  width: 55px;\n  height: 55px;\n  object-fit: cover;\n  border-radius: 8px;\n}\n\n.logo-container {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.edit-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out;\n  cursor: pointer;\n}\n.edit-overlay mat-icon {\n  color: white;\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n}\n\n.logo-container:hover .edit-overlay {\n  opacity: 1;\n}\n\n.clickable-logo {\n  cursor: pointer;\n}\n\n.brand-text {\n  min-width: 0;\n  flex: 1;\n}\n\n.org-name {\n  font-size: 12px;\n  font-weight: 600;\n  color: #1a2060;\n  direction: rtl;\n  text-align: right;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.org-subtitle {\n  font-size: 10px;\n  font-weight: 400;\n  color: #8898c8;\n  text-align: right;\n}\n\n.selector-wrap {\n  margin-top: 12px;\n}\n\n.pill-select {\n  position: relative;\n}\n\n.pill-select + .pill-select {\n  margin-top: 8px;\n}\n\n.pill-button {\n  width: 100%;\n  border-radius: 8px;\n  border: 1px solid #e0e4f8;\n  background: #f4f6ff;\n  padding: 8px 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  transition: border-color 150ms ease, background 150ms ease;\n}\n\n.pill-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.pill-text-col {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  flex: 1;\n  text-align: start;\n}\n\n.pill-value {\n  font-size: 11.5px;\n  font-weight: 500;\n  color: var(--color-sidenav-text);\n  flex: 1;\n  text-align: start;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pill-sub {\n  font-size: 9.5px;\n  color: #8898c8;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  line-height: 1.2;\n}\n\n.pill-chevron {\n  font-size: 18px;\n  width: 18px;\n  height: 18px;\n  color: #8898c8;\n  transition: transform 150ms ease;\n}\n\n.pill-chevron.open {\n  transform: rotate(180deg);\n}\n\n.pill-options {\n  background: #ffffff;\n  border: 1px solid #e0e4f8;\n  border-top: 0;\n  border-radius: 0 0 8px 8px;\n  box-shadow: 0 4px 12px rgba(40, 53, 147, 0.1);\n  overflow: hidden;\n}\n\n.pill-option {\n  width: 100%;\n  border: 0;\n  background: transparent;\n  text-align: start;\n  padding: 9px 14px;\n  font-size: 12px;\n  font-weight: 400;\n  color: #5a6888;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: background 150ms ease, color 150ms ease;\n}\n\n.pill-option .pill-dot {\n  opacity: 0;\n}\n\n.pill-option:hover {\n  background: #f4f6ff;\n  color: var(--color-sidenav-text);\n}\n\n.pill-option.selected {\n  color: var(--color-sidenav-text);\n  font-weight: 600;\n}\n\n.pill-option.selected .pill-dot {\n  opacity: 1;\n}\n\n.pill-option-col {\n  display: flex;\n  flex-direction: column;\n  min-width: 0;\n  flex: 1;\n  text-align: start;\n}\n\n.pill-service-title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pill-service-sub {\n  font-size: 10px;\n  font-weight: 400;\n  color: #8898c8;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.pill-select.role .pill-dot {\n  background: var(--color-pill-role-dot);\n  box-shadow: 0 0 0 2px var(--shadow-primary-sm);\n}\n\n.pill-select.role .pill-button:hover {\n  border-color: var(--color-pill-role-dot);\n  background: #eef0fc;\n}\n\n.pill-select.service .pill-button {\n  border-color: #e0f2f0;\n  background: #f4fffe;\n}\n\n.pill-select.service .pill-dot {\n  background: #00897b;\n  box-shadow: 0 0 0 2px rgba(0, 137, 123, 0.2);\n}\n\n.pill-select.service .pill-value {\n  color: #00695c;\n}\n\n.pill-select.service .pill-button:hover {\n  border-color: #00897b;\n  background: #e8f5f3;\n}\n\n.pill-select.service .pill-option:hover {\n  background: #e8f5f3;\n  color: #00695c;\n}\n\n.pill-select.service .pill-option.selected {\n  color: #00695c;\n}\n\n.nav-body {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overflow-x: hidden;\n  padding: 12px 10px 16px;\n  scrollbar-width: thin;\n  scrollbar-color: #e0e4f0 transparent;\n}\n\n.nav-body::-webkit-scrollbar {\n  width: 3px;\n}\n\n.nav-body::-webkit-scrollbar-thumb {\n  background: #e0e4f0;\n  border-radius: 3px;\n}\n\n.user-footer {\n  flex-shrink: 0;\n  border-top: 1px solid #f0f3fc;\n  background: #fafbff;\n  padding: 10px 14px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.user-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--color-sidenav-avatar-start), var(--color-sidenav-avatar-end));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 13px;\n  font-weight: 700;\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.user-info {\n  min-width: 0;\n  flex: 1;\n}\n\n.user-name {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: #1a2060;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.user-role {\n  font-size: 10px;\n  font-weight: 400;\n  color: #8898c8;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.logout-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 7px;\n  border: 1px solid #e8ecf6;\n  background: #fff;\n  color: #8898c8;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;\n}\n\n.change-password-btn {\n  width: 28px;\n  height: 28px;\n  border-radius: 7px;\n  border: 1px solid #e8ecf6;\n  background: #fff;\n  color: #8898c8;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;\n}\n\n.change-password-btn .material-icons {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n}\n\n.change-password-btn:hover {\n  background: #eef3ff;\n  border-color: #c8d7ff;\n  color: var(--color-sidenav-text);\n}\n\n.logout-btn .material-icons {\n  font-size: 16px;\n  width: 16px;\n  height: 16px;\n}\n\n.logout-btn:hover {\n  background: #fff0f0;\n  border-color: #ffcdd2;\n  color: #e53935;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
